module.exports = "label {\n  cursor: pointer; }\n\nfa-icon {\n  color: #6c757d; }\n\nfa-icon + fa-icon {\n    margin-left: 1px; }\n"